module.exports = __webpack_public_path__ + "media/images/arrow-right-red-25171e06cbefffe1e786ed1bf0d71ef0.png";